<template>
  <div class="database-simple-table-container">
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :pagination="pagination"
      row-key="id"
      :scroll="scroll"
      :rowClassName="() => 'pdf-split-flag'"
    >
      <template slot="name" slot-scope="text, record">
        <a-tooltip placement="topLeft" :title="text">
          <a @click="$refs.detailDrawer.show(record.id)">
            {{ text }}
          </a>
        </a-tooltip>
      </template>
      <template slot="databaseType" slot-scope="record">
        {{ $t(`database_type.${record}`) }}
      </template>
      <template slot="status" slot-scope="text">
        <source-status-tag :status="text"></source-status-tag>
      </template>
    </a-table>

    <database-drawer ref="detailDrawer"></database-drawer>
  </div>
</template>

<script>
import DatabaseDrawer from '@/components/drawer/DatabaseDrawer'
import SourceStatusTag from '@/components/tag/SourceStatusTag'

export default {
  name: 'DatabaseSimpleTable',
  components: {
    DatabaseDrawer,
    SourceStatusTag
  },
  props: {
    dataSource: {
      type: Array
    },
    pagination: {
      type: [Boolean, Object],
      default: () => {
        return { pageSize: 5 }
      }
    },
    scroll: {
      type: Object,
      default: () => {
        return { x: scrollX }
      }
    }
  },
  data () {
    return {
      columns: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: this.pagination === false ? false : 'left',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'database_type',
          title: '数据库类型',
          width: 160,
          scopedSlots: {
            customRender: 'databaseType'
          }
        },
        {
          dataIndex: 'version',
          title: '版本',
          width: 160,
          ellipsis: true
        },
        {
          dataIndex: 'status',
          align: 'center',
          title: '状态',
          width: 100,
          scopedSlots: {
            customRender: 'status'
          }
        }
      ]
    }
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        sum += column.width
      })
      return sum
    }
  }
}
</script>
<style lang="less">
.database-simple-table-container {
  .ant-table {
    overflow: hidden;
    border-radius: 8px;
    .ant-table-content {
      .ant-table-placeholder {
        border: none;
      }
      .ant-table-thead > tr > th {
        height: 38px !important;
        padding: 0 16px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid #f5f5f5;
        border-radius: 0;
      }
      .ant-table-tbody > tr {
        background: #fff;
        height: 46px;
        max-height: 46px;
        & > td {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          padding: 8px 16px;
          border-bottom: 1px solid #f5f5f5;
        }
      }
      .ant-table-fixed-columns-in-body:not([colspan]) > * {
        display: none;
      }
    }
  }

  .ant-pagination {
    .ant-pagination-prev, .ant-pagination-next, .ant-pagination-item {
      width: 24px;
      height: 24px;
      line-height: 24px;
      min-width: 24px;
    }
  }
}
</style>
